<template>
  <div class="motion-bank-wallet card">
    <img src="../../assets/icons/motionpay.svg" alt="" height="16" />

    <p class="motion-desc">
      Daftar / sambungkan akun motionPay anda
    </p>

    <button disabled class="motion-bank-button">
      <span>Belum Tersedia</span>
    </button>
  </div>
</template>

<style scoped>
.motion-bank-wallet {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
}

.motion-bank-wallet > img {
  align-self: flex-start;
  margin: 0;
  height: 16px;
  width: auto;
}

.motion-desc {
  margin: 0;
  color: #9aa0a6;
  font-size: 14px;
  line-height: 1.25;
  padding-top: 2px;
  font-weight: 500;
}

.motion-bank-button {
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 10px;
  background: #eef0f3;
  color: #b0b6bf;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: not-allowed;
  padding: 0 12px;
}

.motion-bank-button span {
  font-weight: 700;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: #b0b6bf;
}

.motion-bank-button:disabled .motion-arrow {
  display: none;
}
</style>
